import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import RateInput from '../common/RateInput';
import SelectInputWithSymbol from '../common/SelectInputWithSymbol/SelectInputWithSymbol';
import { putRequest } from '../../requestUtils';
import dollarImage from '../../../assets/images/icons/dollar.svg';
import './FullTimeRatesModal.scss';
var requiredFields = ['baseAnnualPay', 'conversionFee'];
var FullTimeRatesModal = /*#__PURE__*/function (_Component) {
  function FullTimeRatesModal(props) {
    var _this;
    _classCallCheck(this, FullTimeRatesModal);
    _this = _callSuper(this, FullTimeRatesModal, [props]);
    _this.state = {
      baseAnnualPay: props.baseAnnualPay,
      conversionFee: props.conversionFee,
      projectTakeRate: props.projectTakeRate,
      quickbooksPaymentTerm: props.quickbooksPaymentTerm
    };
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    _this.handleUpdateProposal = _this.handleUpdateProposal.bind(_this);
    _this.updateTakeRate = _this.updateTakeRate.bind(_this);
    return _this;
  }
  _inherits(FullTimeRatesModal, _Component);
  return _createClass(FullTimeRatesModal, [{
    key: "ableToSubmit",
    value: function ableToSubmit() {
      var _this2 = this;
      return requiredFields.reduce(function (soFar, field) {
        return soFar && _this2.state[field];
      }, true);
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "handleUpdateProposal",
    value: function handleUpdateProposal() {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        putUrl = _this$props.putUrl,
        mode = _this$props.mode;
      var _this$state = this.state,
        baseAnnualPay = _this$state.baseAnnualPay,
        conversionFee = _this$state.conversionFee,
        projectTakeRate = _this$state.projectTakeRate,
        quickbooksPaymentTerm = _this$state.quickbooksPaymentTerm;
      var rates = {
        base_annual_pay: baseAnnualPay,
        conversion_fee: conversionFee
      };
      putRequest(putUrl, {
        rates: rates,
        clora_take_rate: projectTakeRate,
        update_proposal_rate: mode === 'edit',
        quickbooks_payment_term: quickbooksPaymentTerm
      }, csrfToken).then(function () {
        window.location.reload();
      });
    }
  }, {
    key: "calculatedTakeRate",
    value: function calculatedTakeRate() {
      var _this$state2 = this.state,
        baseAnnualPay = _this$state2.baseAnnualPay,
        conversionFee = _this$state2.conversionFee;
      var rawRate = conversionFee / baseAnnualPay;
      return Math.round(rawRate * 10000) / 100;
    }
  }, {
    key: "updateTakeRate",
    value: function updateTakeRate() {
      if (isNaN(this.calculatedTakeRate()) || this.calculatedTakeRate() < 0) return;
      this.setState({
        projectTakeRate: this.calculatedTakeRate()
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(val, name) {
      this.setState(_defineProperty({}, name, val), this.updateTakeRate);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        style = _this$props2.style,
        triggerText = _this$props2.triggerText,
        triggerStyle = _this$props2.triggerStyle,
        submitButtonText = _this$props2.submitButtonText,
        quickbooksPaymentTermOptions = _this$props2.quickbooksPaymentTermOptions;
      var _this$state3 = this.state,
        baseAnnualPay = _this$state3.baseAnnualPay,
        conversionFee = _this$state3.conversionFee,
        projectTakeRate = _this$state3.projectTakeRate,
        quickbooksPaymentTerm = _this$state3.quickbooksPaymentTerm;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: triggerText,
        buttonStyles: "btn btn-sm ".concat(style, " ").concat(triggerStyle),
        submitButtonText: submitButtonText,
        submitDisabled: !this.ableToSubmit(),
        cancelButtonText: "Cancel",
        handleSubmit: this.handleUpdateProposal,
        triggerType: "link",
        idKey: "fte-rates-modal",
        modalSize: "md"
      }, /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("div", {
        className: " mb-3 "
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-1 required"
      }, "Base Annual Pay"), /*#__PURE__*/React.createElement(RateInput, {
        id: "proposal-base-annual-pay",
        value: baseAnnualPay,
        onAnswerChange: function onAnswerChange(val) {
          return _this3.handleChange(val, 'baseAnnualPay');
        },
        placeholder: "Base Annual Pay"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pr-5",
        src: dollarImage,
        alt: "dollar sign"
      }))), /*#__PURE__*/React.createElement("div", {
        className: " mb-3 "
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-1 required"
      }, "Conversion Fee"), /*#__PURE__*/React.createElement(RateInput, {
        id: "proposal-conversion-fee",
        value: conversionFee,
        onAnswerChange: function onAnswerChange(val) {
          return _this3.handleChange(val, 'conversionFee');
        },
        placeholder: "Conversion Fee"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pr-5",
        src: dollarImage,
        alt: "dollar sign"
      }))), /*#__PURE__*/React.createElement("div", {
        className: " mb-3 "
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-1 required"
      }, "Project Take Rate"), /*#__PURE__*/React.createElement("div", {
        className: "input-group w-75"
      }, /*#__PURE__*/React.createElement("input", {
        id: "project-take-rate",
        type: "number",
        className: "form-control rate-input",
        value: projectTakeRate,
        placeholder: "Project Take Rate",
        readOnly: true
      }))), /*#__PURE__*/React.createElement(SelectInputWithSymbol, {
        label: /*#__PURE__*/React.createElement("h2", {
          className: "input-label",
          style: {
            color: '#007766'
          },
          required: true
        }, "Quickbooks Payment Term"),
        placeholder: "Quickbooks Payment Term",
        inputName: "quickbooksPaymentTerm",
        onChange: function onChange(e) {
          return _this3.handleChange(e.value, 'quickbooksPaymentTerm');
        },
        errors: "",
        containerWidth: "80%",
        value: {
          value: quickbooksPaymentTerm,
          label: quickbooksPaymentTerm
        },
        options: quickbooksPaymentTermOptions
      })));
    }
  }]);
}(Component);
FullTimeRatesModal.propTypes = {
  mode: PropTypes.oneOf(['edit', 'execute']),
  style: PropTypes.string,
  triggerStyle: PropTypes.string,
  triggerText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  csrfToken: PropTypes.string.isRequired,
  putUrl: PropTypes.string.isRequired,
  submitButtonText: PropTypes.string,
  baseAnnualPay: PropTypes.number,
  conversionFee: PropTypes.number,
  projectTakeRate: PropTypes.number.isRequired,
  quickbooksPaymentTerm: PropTypes.string.isRequired,
  quickbooksPaymentTermOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  }))
};
FullTimeRatesModal.defaultProps = {
  mode: 'execute',
  baseAnnualPay: null,
  conversionFee: null,
  triggerStyle: '',
  triggerText: 'Executed Agreement',
  submitButtonText: 'Execute Agreement',
  style: '',
  quickbooksPaymentTermOptions: []
};
export default FullTimeRatesModal;